




































































import { PropType } from 'vue';
import { defineComponent, toRefs } from '@vue/composition-api';
import { useHashtagPreOnline } from '../hooks/use-hashtag-pre-online';
import { AdgroupFormData, CampaignFormData } from '@tt4b/ttam-enums';
export default defineComponent({
  name: 'HashtagPreOffline',
  props: {
    campaignData: {
      type: Object as PropType<CampaignFormData>,
      default: () => ({}),
    },
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      default: () => ({}),
    },
  },
  setup(props, ctx) {
    const { adgroupData } = toRefs(props);
    const {
      removePreOfflineTags,
      showRemovePreOfflineTagsDialog,
      onRemovePreOfflineTagsDialogClose,
      removeAllPreOfflineTags,
      closeOnePreOfflineTag,
      displayPreOfflineHashtags,
      handlePreOfflineHashTag,
    } = useHashtagPreOnline({ adgroupData, ctx });

    return {
      removePreOfflineTags,
      showRemovePreOfflineTagsDialog,
      onRemovePreOfflineTagsDialogClose,
      removeAllPreOfflineTags,
      closeOnePreOfflineTag,
      displayPreOfflineHashtags,
      handlePreOfflineHashTag,
    };
  },
});
